import * as Sentry from '@sentry/browser';

import { getDevStackMode } from './devStackMode';
import { getUserId } from './cognito';
import { webAppVersion } from '../../Version';

const SENTRY_DSN = 'https://21259d90a1191a86351ffa9aad5196a7@o188289.ingest.us.sentry.io/4507776787087360';

let isInitialized = false;

export function initializeSentry() {
    if (isInitialized) return;

    try {
        Sentry.init({
            dsn: SENTRY_DSN,
            environment: process.env.NODE_ENV,
            integrations: [],
            sampleRate: 1, // 100% of the Sentry events are sent to their backend
            release: webAppVersion,
        });

        Sentry.setTags({
            environment: process.env.NODE_ENV,
            userId: getUserId(),
            isDevStack: getDevStackMode(),
        });

        isInitialized = true;
    } catch (error) {
        console.warn('Failed to initialize Sentry:', error);
    }
}

export function captureSentryException(exception: unknown) {
    if (window.location.hostname === 'localhost') return;

    // Initialize Sentry if not already done
    if (!isInitialized) {
        initializeSentry();
    }

    Sentry.captureException(exception);
}
